import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { CustomerContactViewModel } from '@typeDefinitions/customerTypes';
import { logError } from '@utils/errorLogging';
import { createError } from '@utils/errorUtils';
import { UserInfoModel } from '@store/orders/types';

export async function fetchOfficeGroups(id: number) {
  try {
    const response = await apiClient.get(`Office/group/names/${id}`);
    return response as unknown as Record<string, string | number>[];
  } catch (error: unknown) {
    logError('fetchOfficeGroups', error as Error);
    throw createError(error, 'Failed to fetch office groups');
  }
}

export async function fetchUserInfo(Id: number) {
  try {
    const response: V4ApiResponse<CustomerContactViewModel> =
      await apiClient.get(`User/userinfo/${Id}`);
    return response.value as unknown as CustomerContactViewModel;
  } catch (error: unknown) {
    logError('fetchUserInfo', error as Error);
    throw createError(error, 'Failed to fetch user info');
  }
}

export async function fetchUserInfoUserModel(Id: number) {
  try {
    const response: V4ApiResponse<UserInfoModel> = await apiClient.get(
      `User/userinfo/${Id}`,
    );
    return response.value as unknown as UserInfoModel;
  } catch (error: unknown) {
    logError('fetchUserInfoUserModel', error as Error);
    throw createError(error, 'Failed to fetch user info');
  }
}
